import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3035147f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3035147f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035147f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3035147f')) {
      api.createRecord('3035147f', component.options)
    } else {
      api.reload('3035147f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3035147f&scoped=true&", function () {
      api.rerender('3035147f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/arbitrator/caseAvoid/index.vue"
export default component.exports